// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

#consortium {
    background-color: #060000;
    padding: 50px 0;
  }
  
  .consortium-content {
    max-width: 960px;
    margin: 0 auto;
    text-align: center;
  }
  
  .section-title {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 30px;
    color: #766f6f;
    text-align: center;
  }

  .section-description {
    font-size: 1.2em;
    font-weight: bold;
    margin-bottom: 30px;
    color: #766f6f;
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 60%;
  }
  
  .consortium-list {
    list-style: none;
    padding: 0;
    display: flex;
    text-align: center;
  }
  
  .consortium-item {
    font-size: 1.5rem;
    margin-right: 20px;
    padding: 10px;
    border: 2px solid #333;
    border-radius: 5px;
    color: #959090;
    transition: all 0.3s ease;
    text-align: center;
  }
  
  .consortium-item:hover {
    background-color: #7d7777;
    color: #fff;
  }
  

  #team {
    background-color: #060000;
    padding: 50px 0;
    text-align: center;
  }
  
  .team-content {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
  }
  
  .team-list {
    list-style: disc;
    padding: auto;
    text-align: center;
  }
  
  .team-item {
    font-size: 1.2rem;
    margin-bottom: 6px;
    color: #9a9595;
    text-align: center;
  }

.grid-section {
  display: flex;
  justify-content: space-around;
}

.grid-entity {
  flex: 1 1;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.entity-title {
  margin-bottom: 10px; /* Adjust margin as needed */
}

.section-title {
  margin-bottom: 10px; /* Adjust margin as needed */
}

.entity-list {
  padding: 0;
  list-style: none;
}

.entity-item {
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Consortium.css"],"names":[],"mappings":";;AAEA;IACI,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;;EAGA;IACE,yBAAyB;IACzB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;AAEF;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["\n\n#consortium {\n    background-color: #060000;\n    padding: 50px 0;\n  }\n  \n  .consortium-content {\n    max-width: 960px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .section-title {\n    font-size: 2.5rem;\n    font-weight: bold;\n    margin-bottom: 30px;\n    color: #766f6f;\n    text-align: center;\n  }\n\n  .section-description {\n    font-size: 1.2em;\n    font-weight: bold;\n    margin-bottom: 30px;\n    color: #766f6f;\n    text-align: center;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width: 60%;\n  }\n  \n  .consortium-list {\n    list-style: none;\n    padding: 0;\n    display: flex;\n    text-align: center;\n  }\n  \n  .consortium-item {\n    font-size: 1.5rem;\n    margin-right: 20px;\n    padding: 10px;\n    border: 2px solid #333;\n    border-radius: 5px;\n    color: #959090;\n    transition: all 0.3s ease;\n    text-align: center;\n  }\n  \n  .consortium-item:hover {\n    background-color: #7d7777;\n    color: #fff;\n  }\n  \n\n  #team {\n    background-color: #060000;\n    padding: 50px 0;\n    text-align: center;\n  }\n  \n  .team-content {\n    max-width: 800px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .team-list {\n    list-style: disc;\n    padding: auto;\n    text-align: center;\n  }\n  \n  .team-item {\n    font-size: 1.2rem;\n    margin-bottom: 6px;\n    color: #9a9595;\n    text-align: center;\n  }\n\n.grid-section {\n  display: flex;\n  justify-content: space-around;\n}\n\n.grid-entity {\n  flex: 1;\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.entity-title {\n  margin-bottom: 10px; /* Adjust margin as needed */\n}\n\n.section-title {\n  margin-bottom: 10px; /* Adjust margin as needed */\n}\n\n.entity-list {\n  padding: 0;\n  list-style: none;\n}\n\n.entity-item {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
